"use strict";
// temp (for in-console db-upgrades and such)
// ==========
/*export async function GetDBUpdatesFor_MakeNodesPrivate_Recursive(mapID: string, nodeID: string, runInfo = {nodesVisited: new Set<string>()}) {
    if (runInfo.nodesVisited.has(nodeID)) return;
    runInfo.nodesVisited.add(nodeID);
    const node = await GetAsync(()=>GetNodeL2(nodeID));

    let dbUpdates = {};
    // if (node.ownerMapID != mapID) {
    if (node.ownerMapID == null) {
        dbUpdates[`nodes/${nodeID}/.ownerMapID`] = mapID;
    }
    if (node.children) {
        for (const childID of node.children.VKeys()) {
            dbUpdates = MergeDBUpdates(dbUpdates, await GetDBUpdatesFor_MakeNodesPrivate_Recursive(mapID, childID));
        }
    }
    return dbUpdates;
}*/ 
